import schedule_5 from '@/public/features/estimating/Access-to-Consumer-Financing-Options.webp';
import schedule_4 from '@/public/features/estimating/Customizable-Payment-Schedules.webp';
import schedule_2 from '@/public/features/estimating/Enhanced-Estimate-Details-_1_.webp';
import schedule_1 from '@/public/features/estimating/On-site-proposal-creation-_1_.webp';
import bg from '@/public/features/estimating/project-661178fed8b74.webp';
import schedule_3 from '@/public/features/estimating/Streamlined-Approval-Process-_1_.webp';
import app_2 from '@/public/features/estimating/What-is-invoicing-software-_1_.webp';
import explore_image from '@/public/features/explore.webp';
import app_1 from '@/public/features/scheduling/App_1.webp';
import { CalendarIcon, CardIcon, ToolsIcon, WalletIcon } from '@/public/icons';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const intro = {
  tag: 'Field Service Estimate Software',
  description: `Discover the key to efficiency with our invoicing and estimates software, which is designed to streamline your financial operations. Enjoy the benefits of real-time accuracy, seamless integration, and an intuitive user interface. Ideal for businesses of all sizes, our job estimate software is your solution for better financial management and accelerated growth.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Elevate Your Business with',
  second_title: 'Top Invoicing & Estimates Software',
};

const faq = {
  title: 'FAQ',
  items: [
    {
      title: 'Can I convert an estimate into a job within the app?',
      text: `Our app for estimates allows you to seamlessly transition an estimate into a live job with just a few clicks, streamlining your workflow and saving time.`,
    },
    {
      title: `Who typically uses service estimate software?`,
      text: `Service estimate software is ideal for contractors, freelancers, and businesses in industries like construction, field service, and consulting, who require accurate job estimates.`,
    },
    {
      title: `What types of data analysis can I perform with estimation software?`,
      text: `Our job estimate software for contractors provides robust data analysis tools, such as cost performance tracking and estimate versus actuals, to help you refine future estimates.`,
    },
    {
      title: `Why is field service estimation software crucial for small businesses?`,
      text: `Field job estimation system streamlines the quoting process, ensuring small businesses remain competitive by providing quick, accurate estimates with a professional touch.`,
    },
  ],
};

const testimonals = {
  title: 'Our Testimonials',
  description: '',
  items: [
    {
      text: `Orcatec has revolutionized how we handle estimates. It's incredibly user-friendly and adaptable to our needs. Even as we expand, Orcatec will scale with us effortlessly.`,
      name: 'Jordan M.,',
      position: 'BuildRight Contractors',
    },
    {
      text: `The flexibility of Orcatec's software is unmatched. Their job estimating software free starter package got us hooked, and now we can't imagine our workflow without it. It's an essential tool in our arsenal.`,
      name: 'Taylor E.,',
      position: 'Founder, Precision Electricians',
    },
    {
      text: `With Orcatec, we've seen a notable increase in our efficiency. Mobile compatibility means we can work from anywhere, ensuring we stay ahead in our fast-paced industry. `,
      name: 'Chris D.,',
      position: 'Operations Manager',
    },

    {
      text: `Orcatec has revolutionized how we handle estimates. It's incredibly user-friendly and adaptable to our needs. Even as we expand, Orcatec will scale with us effortlessly.`,
      name: 'Jordan M.,',
      position: 'BuildRight Contractors',
    },
    {
      text: `The flexibility of Orcatec's software is unmatched. Their job estimating software free starter package got us hooked, and now we can't imagine our workflow without it. It's an essential tool in our arsenal.`,
      name: 'Taylor E.,',
      position: 'Founder, Precision Electricians',
    },
    {
      text: `With Orcatec, we've seen a notable increase in our efficiency. Mobile compatibility means we can work from anywhere, ensuring we stay ahead in our fast-paced industry. `,
      name: 'Chris D.,',
      position: 'Operations Manager',
    },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Be sure to check your hub for all things related to estimate software for contractors. Whether you're a seasoned pro or new to the industry, our blog offers insights, tips, and trends that can help elevate your business. `,
};

const bookDemo = {
  title: `Book A Demo To Transform Your Estimates!`,
  description: `Embark on a journey to business optimization with Orcatec. Fill in your details below, and our team will reach out to help you harness the full potential of our field service estimation software.`,
};

const articles = {
  title: `How Does Job Estimate Software Work?`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_1,
        alt: 'On-Site Proposal Creation',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'On-Site Proposal Creation',
      text: `Contractors can now quickly draft compelling proposals while they are at the work site with the client, leveraging Orcatec mobile app's ability to pull in data and generate a complete offer on the spot.`,
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_2,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Enhanced Estimate Details',
      text: `Orcatec enables contractors to produce highly detailed and client-friendly estimates, breaking down costs and work items so that clients can easily understand what they're paying for at the job estimator app or web version.`,
    },

    {
      type: ArticleType.HORIZONTAL,
      image: {
        path: schedule_3,
        alt: 'Streamlined Approval Process',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Streamlined Approval Process',
      text: 'With the flexibility to send estimates via text message, email, or even secure an immediate on-site signature through a mobile device, the approval process becomes faster, securing a swift go-ahead for the project.',
    },
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_5,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Access to Consumer Financing Options',
      text: `The online estimating software can introduce options for consumer financing, allowing contractors to be paid upfront while offering customers the convenience of paying in installments.`,
    },
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_4,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Customizable Payment Schedules',
      text: `Contractors can set up structured payment schedules within the software, ensuring that the price is fixed and both parties clearly understand the payment timeline.`,
    },
  ],
};

const fullArticle1 = {
  image: {
    path: app_1,
    alt: `Why Orcatec is Right For You?`,
  },
  title: `Why Orcatec is Right For You?`,
  description: `Choosing the right online estimate software for your business can significantly impact your project planning, budgeting, and overall success. Orcatec stands out in the competitive landscape of estimate software for several compelling reasons, making it an excellent choice for businesses looking to optimize their estimating processes. Check the main advantages of Orcatec that highlight why it might be the right choice for you:`,
  item: [
    {
      title: 'Zero-Cost Package',
      description:
        'Orcatec offers a free starter package, allowing businesses to explore and utilize basic functionalities without any initial investment. This risk-free approach is particularly beneficial for small businesses or freelancers who are cautious about overhead costs.',
    },
    {
      title: 'Flexible Options',
      description:
        'As your business grows or your needs change, Orcatec’s flexible pricing model makes it easy to add or remove features, ensuring that the software continues to meet your requirements without unnecessary expenses.',
    },
    {
      title: 'Easy-to-use Interface',
      description: `The software’s intuitive design ensures straightforward customization and daily use, reducing new users' learning curve and enhancing productivity.`,
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What Is Estimate Software?`,
  },
  title: `What Is Estimate Software?`,
  description: `Estimate software is a cutting-edge digital tool tailored specifically for apartment and house maintenance contractors such as plumbers, HVAC technicians, electricians, builders, and garage door repairmen. This sophisticated online estimates software, significantly enhances the process of generating work estimates, transforming traditional methods into a modernized digital workflow:`,
  item: [
    {
      title: 'Personalization',
      description:
        'Contractors can now customize their estimates with unique branding elements like company logos, creating a distinct and professional look that aligns with their business identity.',
    },
    {
      title: 'Clear Cooperation',
      description:
        'The software breaks down the work into clear stages, allowing customers to understand precisely what they are being charged for, promoting transparency and trust.',
    },

    {
      title: 'Single Ecosystem',
      description: `The estimating job software, as a rule, is integrated into existing business management systems, such as the Orcatec system, creating a cohesive ecosystem for housing maintenance companies.`,
    },
  ],
};

const explore = {
  title: 'Explore More ',
  subtitle: 'Tools For Job Success',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
  for the latest trends and tips in service scheduling software free`,
  image: explore_image,
  items: [
    {
      title: 'Complete Job & Invoice',
      path: IRoutePath.FEATURES_INVOICING,
      icon: WalletIcon,
      items: [
        {
          title: 'Sales Proposal Tool',
          path: '',
        },

        {
          title: 'Invoicing',
          path: '',
        },
        {
          title: 'Estimates',
          path: '',
        },
        {
          title: 'Quoting',
          path: '',
        },
      ],
    },
    {
      title: 'Scheduling & Dispatching',
      path: IRoutePath.FEATURES_SCHEDULIG,
      icon: CalendarIcon,
      items: [
        {
          title: 'Employee GPS Tracking',
          path: '',
        },
        {
          title: 'Scheduling Software',
          path: '',
        },
        {
          title: 'Route Optimization',
          path: '',
        },
        {
          title: 'Field Service App',
          path: '',
        },
        {
          title: 'Voice Solutions',
          path: '',
        },
        {
          title: 'Dispatching',
          path: '',
        },
      ],
    },
    {
      title: 'Get Paid & Expenses',
      path: IRoutePath.FEATURES,
      icon: CardIcon,
      items: [
        {
          title: 'Commissions Management',
          path: '',
        },
        {
          title: 'Home Services Marketing',
          path: '',
        },
        {
          title: 'Automated Direct Mail',
          path: '',
        },
        {
          title: 'Consumer Financing',
          path: '',
        },
        {
          title: 'Advanced Reporting',
          path: '',
        },
        {
          title: 'Expenses Tracking',
          path: '',
        },

        {
          title: 'Contractor Payroll',
          path: '',
        },
        {
          title: 'Card Reader',
          path: '',
        },
      ],
    },
    {
      title: 'Job Management',
      icon: ToolsIcon,
      path: IRoutePath.FEATURES,
      items: [
        {
          title: 'Work Order Management',
          path: '',
        },
        {
          title: 'Field Service CRM',
          path: '',
        },
        {
          title: 'Job Management',
          path: '',
        },
        {
          title: 'Job Tracking',
          path: '',
        },
        {
          title: 'Job Costing',
          path: '',
        },
      ],
    },
  ],
};

export {
  articles,
  blog,
  bookDemo,
  faq,
  fullArticle1,
  fullArticle2,
  intro,
  testimonals,
  explore,
};
